//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import { getAliasedDateRange } from '@components/date-range-picker/dateRangePickerModels';
import DateString from '@models/DateString';
import TimeZoneId from '@models/TimeZoneId';

export const checkHasReachedEndOfContent = (
  mediaCount: number,
  requestLimit: number,
): boolean => {
  return mediaCount < requestLimit;
};

function getOffsetDateFromNow(
  numberOfDays: number,
  isFutureDate: boolean,
  timeZoneId: TimeZoneId,
): DateString {
  const now = new Date();

  const adjustedDate = isFutureDate
    ? now.setDate(now.getDate() + numberOfDays)
    : now.setDate(now.getDate() - numberOfDays);

  return DateString.fromTimestamp(adjustedDate, timeZoneId);
}

function getIsTestDateRangeWithinTargetDateRange(
  testRange: {
    start: DateString;
    end: DateString;
  },
  targetRange: {
    start: DateString;
    end: DateString;
  },
) {
  const isStartWithinTargetRange = DateString.isWithin(testRange.start, {
    minDate: targetRange.start,
    maxDate: targetRange.end,
  });

  const isEndWithinTargetRange = DateString.isWithin(testRange.end, {
    minDate: targetRange.start,
    maxDate: targetRange.end,
  });

  return isStartWithinTargetRange && isEndWithinTargetRange;
}

export function getOptionalCampaignDateRangeAliases(
  campaingStart: DateString,
  campaignEnd: DateString,
  timeZoneId: TimeZoneId,
) {
  const nowDateString = DateString.fromTimestamp(new Date(), timeZoneId);

  const sevenDaysAgoDateString = getOffsetDateFromNow(7, false, timeZoneId);
  const thirtyDaysAgoDateString = getOffsetDateFromNow(30, false, timeZoneId);

  return [
    ...(getIsTestDateRangeWithinTargetDateRange(
      { start: sevenDaysAgoDateString, end: nowDateString },
      { start: campaingStart, end: campaignEnd },
    )
      ? [getAliasedDateRange('last7Days', timeZoneId)]
      : []),
    ...(getIsTestDateRangeWithinTargetDateRange(
      { start: thirtyDaysAgoDateString, end: nowDateString },
      { start: campaingStart, end: campaignEnd },
    )
      ? [getAliasedDateRange('last30Days', timeZoneId)]
      : []),
  ];
}
